import React from "react";
import { Modal } from "react-bootstrap";

export default function ConfirmationDeleteAccount({ show, onHide, onDelete,type }) {
  return (
    <Modal className="modal fade" show={show} centered>
      <div role="document">
        <div>
          <div className="modal-header">
            <h4 className="modal-title fs-20">Confirm {type === "user" ? "Block" : "Delete"}</h4>
          </div>
          <div className="modal-body text-center">
            <p>Are you sure you want to {type === "user" ? "block" : type === "service" ? "delete" : "delete"} this {type === "user" ? "user" : type === "service" ? "service" : "job"}? </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={onHide}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onDelete}
              className="btn btn-danger"
            >
              {type === "user" ? "Block" : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
